import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en/translation.json';
import si from './locales/si/translation.json';
import ta from './locales/ta/translation.json';

const STORAGE_KEY = 'aib_language';

const savedLang = localStorage.getItem(STORAGE_KEY) || 'en';

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: en },
            si: { translation: si },
            ta: { translation: ta },
        },
        lng: savedLang,
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false,
        },
        react: {
            useSuspense: false,
        },
        detection: {
            order: ['localStorage', 'navigator'],
            lookupLocalStorage: STORAGE_KEY,
            caches: ['localStorage'],
        },
    });

export const LANGUAGES = [
    { code: 'en', label: 'English', nativeLabel: 'English' },
    { code: 'si', label: 'Sinhala', nativeLabel: '\u0dc3\u0dd2\u0dc2\u0daf\u0dca\u0daf\u0dca\u0dc2\u0dd4\u0dc0' },
    { code: 'ta', label: 'Tamil', nativeLabel: '\u0ba4\u0bae\u0bbf\u0bb4\u0bcd' },
] as const;

export function changeLanguage(code: string) {
    i18n.changeLanguage(code);
    localStorage.setItem(STORAGE_KEY, code);
}

export default i18n;
